import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useIdempotentAppMutation } from '../use-idempotent-app-mutation.hook';

export const useRequestExercise = () => {
  const {
    mutate: request,
    mutateAsync: requestAsync,
    isPending,
  } = useIdempotentAppMutation([QueryKey.EXERCISE], {
    mutationFn: (
      {
        companyId,
        data,
      }: {
        companyId: string;
        data: {
          payout?: number;
          value: number;
          vestingTaskId: string;
        };
      },
      { headers },
    ) =>
      ApiService.post(
        { endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'request-exercise'] },
        { body: data, headers },
      ),
  });

  return { request, requestAsync, isPending };
};
